import React, { useState } from 'react';
import { setIsTermsAccepted } from '../../redux/slices/termsAndSubSlice';
import { EventPublisher } from '../../utils/publishEvent';
import { v4 as uuidv4 } from 'uuid';
import { ExtraTermProps } from './index';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import { useEffect } from 'react';
import './../text-editor/style.scss';
import { getIsViewIsEdit } from '../../utils/constants';
import { PaddingType } from '../../puck/reusable-props/padding';
import { getPaddingStyles } from '../../utils/helper';
import ArrowDown from '../../../assets/svg/ArrowDown';

export type TermsAndSubscriptionProps = {
  showHeader: boolean;
  headerContent: string;
  showAcknowledgeDropdown: boolean;
  acknowledgeContent: string;
  extraTerms: ExtraTermProps;
  padding: PaddingType;
  currentDeviceType: string;
  checkboxColor: string;
};
export const TermsAndSubscription = ({
  showHeader,
  headerContent,
  showAcknowledgeDropdown,
  acknowledgeContent,
  extraTerms,
  padding,
  currentDeviceType,
  useAppDispatch,
  checkboxColor,
  useAppSelector,
}: TermsAndSubscriptionProps & ReduxDispatchProps & ReduxSelectorProps) => {
  const dispatch = useAppDispatch();
  const isTermsAccepted = useAppSelector(
    state => state.termsAndSub.isTermsAccepted,
  );
  const cartData = useAppSelector(state => state.cart.cartData);
  const storeData = useAppSelector(state => state.store.storeData);
  const publish = EventPublisher.getInstance().publish;

  const [viewTerms, setViewTerms] = useState<boolean>(false);
  const [isopen, setIsOpen] = useState(false);

  useEffect(() => {
    setViewTerms(!extraTerms.defaultCollapse);
  }, [extraTerms.defaultCollapse]);

  return (
    <React.Fragment>
      <div
        className={`py-2 text-editor-content `}
        style={{
          ...getPaddingStyles(padding, currentDeviceType),
        }}>
        <fieldset>
          <legend className="sr-only">Notifications</legend>
          <div className="space-y-5">
            <div className="flex items-center">
              <div className="flex h-6 items-center">
                <input
                  id="comments"
                  aria-describedby="comments-description"
                  name="terms_of_service"
                  type="checkbox"
                  style={{ color: checkboxColor }}
                  className={`h-4 w-4 ml-3 mt-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600`}
                  onChange={() => {
                    const newIsTermsAccepted = !isTermsAccepted;
                    dispatch(setIsTermsAccepted(newIsTermsAccepted));
                    if (newIsTermsAccepted && cartData && storeData) {
                      if (!getIsViewIsEdit()) {
                        publish('AgreeToTerms', {
                          eventId: uuidv4(),
                          shopId: storeData?.ShopID || '',
                          eventName: 'AgreeToTerms',
                          cart: cartData,
                        });
                      }
                    }
                  }}
                  checked={isTermsAccepted}
                />
              </div>
              <div
                className="flex mt-2 items-center justify-between w-full cursor-pointer"
                onClick={() => {
                  setIsOpen(!isopen);
                }}>
                {showHeader && (
                  <div
                    className="checkbox-text ml-3 text-left"
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: headerContent }}
                  />
                )}
                {!showHeader && (
                  <div
                    className="checkbox-text ml-3 text-left"
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: acknowledgeContent }}
                  />
                )}
                {showAcknowledgeDropdown && (
                  <div className={`ml-auto flex py-2`}>
                    <ArrowDown
                      onClick={() => setIsOpen(!isopen)}
                      fill="black"
                      className={`${isopen ? 'transform rotate-[180deg]' : ''}  mx-2`}
                    />
                  </div>
                )}
              </div>
            </div>
            {showHeader && isopen && (
              <div
                className="checkbox-text ml-4 text-left"
                style={{ lineHeight: 1.5 }}
                dangerouslySetInnerHTML={{ __html: acknowledgeContent }}
              />
            )}
          </div>
        </fieldset>
      </div>
      {extraTerms?.viewMoreTerms && (
        <>
          <button
            className="hover:text-indigo-500 text-xs ml-3"
            type="button"
            onClick={() => setViewTerms(!viewTerms)}>
            + Learn More
          </button>
          <div
            className={`mx-auto ml-3 max-w-2xl text-center text-editor-content transition-all duration-500 ease-in-out overflow-hidden ${
              viewTerms ? 'max-h-screen' : 'max-h-0'
            }`}>
            <div
              className="mt-3 text-left"
              style={{ lineHeight: 1.5 }}
              dangerouslySetInnerHTML={{
                __html: extraTerms?.moreTerms,
              }}
            />
          </div>
        </>
      )}
    </React.Fragment>
  );
};
